<template>
    <div v-resize="onResize">
        <div v-if="!eq5d_vas_show" class="text-center ma-4">
            Sorry, screen size too small to display VAS tool. Consider using portait
            size mode.
        </div>

        <div v-if="eq5d_vas_show"
             class="eq5d-vas-wrapper"
             :style="eq5dVasWrapperSize">
            <div class="eq5d-vas-outer-left">
                <div class="eq5d-vas-health-state-today">
                    <div class="eq5d-vas-health-state-text">
                        {{scaleCaptionLeft}}
                    </div>
                    <div class="eq5d-vas-health-state-score headline">
                        {{ eq5d_healthstate_local || eq5d_healthstate}}
                    </div>
                </div>
            </div>
            <div class="eq5d-vas-outer-right">
                <div :class="classEq5dVasTitle"
                     class="eq5d-vas-header pa-2 text-center">
                    The best health you can imagine
                </div>
                <div class="eq5d-vas-main">
                    <div class="eq5d-vas-left">
                        <template v-for="n in 101">
                            <div v-if="eq5d_major_marker_divisor(101 - n)"
                                 :key="n"
                                 class="eq5d-vas-mark subtitle-1">
                                {{ 101 - n }}
                            </div>
                        </template>
                    </div>
                    <div ref="eq5dVasMiddle" class="eq5d-vas-middle">
                        <div v-for="n in 101"
                             :key="n"
                             @click="eq5dVasStepClick($event, 101 - n)"
                             @mouseover="eq5dVasStepHover($event, 101 - n)"
                             @mouseleave="eq5dVasStepLeave"
                             :class="{
                'eq5d-vas-major-step':
                  eq5d_major_marker_divisor(101 - n) == true,
                'eq5d-vas-minor-step':
                  eq5d_major_marker_divisor(101 - n) == false,
              }"></div>
                        <div v-if="eq5d_circle_show"
                             :style="{ top: eq5d_circle_top }"
                             class="eq5d-vas-circle-pointer"></div>
                    </div>
                    <div class="eq5d-vas-right">
                        <div class="eq5d-vas-pointer-wrapper hidden-md-and-down"
                             :style="{ top: eq5d_pointer_top }"
                             v-if="eq5d_pointer_show">
                            <v-icon class="eq5d-vas-pointer-arrow-left">mdi-arrow-left</v-icon>
                            <span class="eq5d-vas-pointer-value">
                                {{
                eq5d_pointer_value
                                }}
                            </span>
                        </div>
                    </div>
                </div>
                <div :class="classEq5dVasTitle"
                     class="eq5d-vas-footer pa-2 text-center">
                    The worst health you can imagine
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            scaleCaptionLeft: {
                type: String,
                default: "HEALTH TODAY",
            },
            value: {
                type: Number,
                default: null,
            },
            pointerYAdjuster: {
                type: Number,
                default: 0,
            },
            marjorMarkerDivisor: {
                type: Number,
                default: 50,
            },
            width: {
                type: String,
                default: "300px",
            },
            height: {
                type: String,
                default: "calc(100vh - 100px)",
            },
        },
        data() {
            return {
                eq5d_healthstate_local: null,
                eq5d_pointer_value: null,
                eq5d_pointer_show: false,
                eq5d_circle_show: false,
                eq5d_vas_show: true,
                eq5d_pointer_top: 0,
                eq5d_circle_top: 0,
                eq5d_circle_left: 0,
                eq5dVasWrapperSize: {
                    flex: `1 1 ${this.height}`,
                    height: `${this.height}`,
                    width: `${this.width}`,
                    "min-height": "-webkit-fill-available",
                },
            };
        },
        methods: {
            eq5dVasStepHover: function (evt, value) {
                this.eq5d_pointer_value = value;
                this.eq5d_pointer_show = true;
                let pointerTop =
                    evt.target.getBoundingClientRect().top + window.scrollY - 62;
                this.eq5d_pointer_top = `${pointerTop}px`;
            },
            eq5dVasStepLeave: function () {
                this.eq5d_pointer_show = false;
            },
            eq5dVasStepClick: function (evt, value) {
                this.eq5d_healthstate = value;

                this.eq5d_circle_top = `${evt.clientY -
                    82 +
                    this.pointerYAdjuster +
                    window.scrollY}px`;

                this.eq5d_circle_show = true;
            },
            eq5d_major_marker_divisor: function (value) {
                if (this.$vuetify.breakpoint.xs && value % 50 == 0) {
                    return true;
                } else if (this.$vuetify.breakpoint.smAndUp && value % 10 == 0) {
                    return true;
                } else {
                    return false;
                }
            },
            onResize: function () {
                this.eq5d_circle_show = false;
                if (window.innerHeight <= 420) {
                    this.eq5d_vas_show = false;
                } else {
                    this.eq5d_vas_show = true;
                }
            },
        },
        computed: {
            eq5d_healthstate: {
                get: function () {
                    if (this.value !== null) {
                        return parseInt(this.value);
                    } else {
                        return null;
                    }
                },
                set: function (value) {
                    this.$emit("input", value);
                    this.eq5d_healthstate_local = value;
                },
            },
            classEq5dVasTitle: function () {
                return {
                    "eq5d-vas-title-sm": this.$vuetify.breakpoint.xs,
                    "eq5d-vas-title-md": this.$vuetify.breakpoint.sm,
                    "eq5d-vas-title-lg": this.$vuetify.breakpoint.mdAndUp,
                };
            },
        },
    };
</script>
<style>
    .eq5d-vas-wrapper {
        display: flex;
        flex-direction: row;
        /* background-color: yellow; */
        margin: 0 auto;
    }

    .eq5d-vas-outer-left {
        flex: 0 0 100px;
        align-self: center;
    }

    .eq5d-vas-outer-right {
        flex: 1 1 60%;
        display: flex;
        flex-direction: column;
    }

    .eq5d-vas-left {
        flex: 1 1 30.3%;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        align-items: flex-end;
        padding-top: 3px;
        padding-bottom: 5px;
    }

    .eq5d-vas-middle {
        flex: 1 1 30.3%;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .eq5d-vas-right {
        flex: 1 1 30.3%;
    }

    .eq5d-vas-main {
        flex: 1;
        display: flex;
        flex-flow: row;
    }

    .eq5d-vas-health-state-today {
        border: 1px solid #000000;
        width: 100px;
        height: 110px;
        text-align: center;
        background-color: #000000;
        color: #ffffff;
        padding: 10px;
        box-sizing: border-box;
    }

    .eq5d-vas-mark {
        width: 50px;
        height: 20px;
        flex: 0 0 20px;
        text-align: right;
    }

    .eq5d-vas-minor-step {
        flex: 1;
        width: 12px;
        height: 1px;
        border-top: 1px solid currentColor;
        border-left: none;
        border-right: none;
        border-bottom: none;
        position: relative;
    }

    .eq5d-vas-major-step {
        flex: 1;
        width: 28px;
        height: 2px;
        border-top: 2px solid currentColor;
        border-left: none;
        border-right: none;
        border-bottom: none;
        position: relative;
    }

    .eq5d-vas-pointer-wrapper {
        height: 20px;
        flex: 0 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        position: absolute;
        box-sizing: border-box;
        margin-top: -10px;
    }

    .eq5d-vas-pointer-value {
        color: #000000;
        font-size: 18px;
    }

    .eq5d-vas-pointer-arrow-left {
        color: #6f9dd1 !important;
        font-size: 20px;
    }

    .eq5d-vas-circle-pointer {
        width: 16px;
        height: 16px;
        border: 1px solid #ff0000;
        background-color: #ff0000;
        border-radius: 8px;
        z-index: 1;
        position: absolute;
        margin-top: 10px;
        pointer-events: none;
        box-sizing: border-box;
    }

    .eq5d-vas-title-sm {
        font-size: 10px;
        font-weight: bold;
    }

    .eq5d-vas-title-md {
        font-size: 11px;
        font-weight: bold;
    }

    .eq5d-vas-title-lg {
        font-size: 12px;
        font-weight: bold;
    }

    .eq5d-vas-health-state-text {
        font-size: 14px;
        font-weight: 500;
    }
</style>
